<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import {compClass} from '@/libraries/utils.js';
</script>

<template>
	<AppLayout>
		<div :class="compClass()" class="page px-4 min-h-full m-auto top-0 bottom-0">
			<div class="px-8 h-[95%] m-auto top-0 bottom-0 flex flex-col items-start justify-evenly">
				<article class="py-6 text-lg">
					<div v-html=" $tg('aboutPage.text1')"/><br>
					<div v-html=" $tg('aboutPage.text2')" /><br>
<!--					text32 perche c-era una cache ineludibile e un incredible error sulla @ di i18n-->
					<div v-html=" $tg('aboutPage.text32').replace('&commat;','@')" /><br>
					<div v-html=" $tg('aboutPage.text42').replace('&commat;','@')" /><br>
					<div v-html=" $tg('aboutPage.text52').replace('&commat;','@')" /><br>
				</article>
				<div class="-mx-10">
					<div class="flex flex-row items-center">
						<div class="basis-1/2">
							<img class="w-full"
								src="/img/about-bottom1.png" alt=""
							/>
						</div>
						<div class="basis-1/2 px-2">
							<img class="w-full"
								src="/img/about-bottom2.jpg" alt=""
							/>
						</div>
					</div>

					<div class="flex flex-row py-12">
						<div class="basis-1/2 px-2">
							<img class="w-full"
								src="/img/about-bottom3.png" alt=""
							/>
						</div>
						<div class="basis-1/2 px-2">
							<img class="w-full"
								src="/img/about-bottom4.png" alt=""
							/>
						</div>
					</div>

					<div class="flex flex-row justify-center">
						<div class="basis-1/2">
							<img class="w-full"
								src="/img/about-bottom5.jpg" alt=""
							/>
						</div>
					</div>

					<a href="https://www.indiciopponibili.com/" target="_blank"
						class="my-8 flex flex-col justify-center items-center text-xl text-black w-full">
						<div class="first-letter:lowercase">{{ $tg('madeBy') }}</div>
						<img class="h-full pt-1"
							src="/img/indici.png" alt="Indici Opponibili"
						/>
					</a>
				</div>
			</div>
		</div>
	</AppLayout>
</template>
